import { Button } from '@repo/ui/components/button';
import { Building, Sun, TrashIcon } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from '@repo/ui/components/dialog';
import type { Court } from '@repo/shared-types';
import { courtApi } from '@repo/api-client';
import { useAsync } from '@repo/ui/hooks/use-async';
import { useRevalidator } from 'react-router';

interface CourtCardProps {
  court: Court;
  clubId: string;
}

export const CourtCard = ({ court, clubId }: CourtCardProps) => {
  const revalidator = useRevalidator();

  const { execute: deleteCourt, loading: loadingDeleteCourt } = useAsync(
    async (courtId: string) => {
      await courtApi.delete(clubId.toString(), courtId);
      revalidator.revalidate();
    }
  );

  const deleteCourtDialog = (
    <div
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <Dialog>
        <DialogTrigger>
          <Button variant="destructive">
            <TrashIcon className="w-4 h-4" />
          </Button>
        </DialogTrigger>
        <DialogContent>
          <DialogTitle>Eliminar Cancha</DialogTitle>
          <DialogDescription>
            ¿Estás seguro de querer eliminar {court.name}? <br /> Esta acción no se puede deshacer.
          </DialogDescription>
          <Button
            variant="destructive"
            onClick={() => deleteCourt(court.id)}
            disabled={loadingDeleteCourt}
          >
            <TrashIcon className="w-4 h-4" />
            Eliminar
          </Button>
        </DialogContent>
      </Dialog>
    </div>
  );

  return (
    <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm">
      <div className="flex flex-col gap-4">
        <div className="text-lg font-medium flex justify-between items-center gap-2">
          Cancha {court.name}
          {deleteCourtDialog}
        </div>
        <div className="flex gap-8">
          <div className="text-sm flex items-center gap-2">
            <Building className="w-4 h-4" />
            <div className="bg-gray-100 rounded-full px-2 py-1 text-xs capitalize">
              {court.type.toLowerCase()}
            </div>
          </div>
          <div className="text-sm flex items-center gap-2">
            <Sun className="w-4 h-4" />
            <div className="bg-gray-100 rounded-full px-2 py-1 text-xs capitalize">
              {court.mode.toLowerCase()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
